// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateOrganizationInviteDTO } from '../models';
import { OrganizationInviteDTO } from '../models';
/**
 * OrganizationInvitesApi - axios parameter creator
 * @export
 */
export const OrganizationInvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept an organization invite
         * @param {string} token 
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrganizationInvite(token: string, organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling acceptOrganizationInvite.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling acceptOrganizationInvite.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/invites/accept`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a User to an Organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationInvite(organizationId: string, createOrganizationInviteDTO: CreateOrganizationInviteDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling createOrganizationInvite.');
            }
            // verify required parameter 'createOrganizationInviteDTO' is not null or undefined
            if (createOrganizationInviteDTO === null || createOrganizationInviteDTO === undefined) {
                throw new RequiredError('createOrganizationInviteDTO','Required parameter createOrganizationInviteDTO was null or undefined when calling createOrganizationInvite.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/invites`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrganizationInviteDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrganizationInviteDTO !== undefined ? createOrganizationInviteDTO : {}) : (createOrganizationInviteDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvite(organizationInviteId: string, organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationInviteId' is not null or undefined
            if (organizationInviteId === null || organizationInviteId === undefined) {
                throw new RequiredError('organizationInviteId','Required parameter organizationInviteId was null or undefined when calling deleteInvite.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling deleteInvite.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/invites/{organizationInviteId}`
                .replace(`{${"organizationInviteId"}}`, encodeURIComponent(String(organizationInviteId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Invites
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByOrganizationId(organizationId: string, accepted?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling fetchInvitesByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/invites`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accepted !== undefined) {
                localVarQueryParameter['accepted'] = accepted;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend an organisation invite for an existing unaccepted invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrganizationInvite(organizationInviteId: string, organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationInviteId' is not null or undefined
            if (organizationInviteId === null || organizationInviteId === undefined) {
                throw new RequiredError('organizationInviteId','Required parameter organizationInviteId was null or undefined when calling resendOrganizationInvite.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling resendOrganizationInvite.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/invites/{organizationInviteId}/resend`
                .replace(`{${"organizationInviteId"}}`, encodeURIComponent(String(organizationInviteId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationInvitesApi - functional programming interface
 * @export
 */
export const OrganizationInvitesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Accept an organization invite
         * @param {string} token 
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrganizationInvite(token: string, organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).acceptOrganizationInvite(token, organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Invite a User to an Organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationInvite(organizationId: string, createOrganizationInviteDTO: CreateOrganizationInviteDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).createOrganizationInvite(organizationId, createOrganizationInviteDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete an invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvite(organizationInviteId: string, organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).deleteInvite(organizationInviteId, organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Invites
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByOrganizationId(organizationId: string, accepted?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationInviteDTO>> {
            const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).fetchInvitesByOrganizationId(organizationId, accepted, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Resend an organisation invite for an existing unaccepted invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrganizationInvite(organizationInviteId: string, organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).resendOrganizationInvite(organizationInviteId, organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationInvitesApi - factory interface
 * @export
 */
export const OrganizationInvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Accept an organization invite
         * @param {string} token 
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrganizationInvite(token: string, organizationId: string, options?: any) {
            return OrganizationInvitesApiFp(configuration).acceptOrganizationInvite(token, organizationId, options)(axios, basePath);
        },
        /**
         * Invite a User to an Organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationInvite(organizationId: string, createOrganizationInviteDTO: CreateOrganizationInviteDTO, options?: any) {
            return OrganizationInvitesApiFp(configuration).createOrganizationInvite(organizationId, createOrganizationInviteDTO, options)(axios, basePath);
        },
        /**
         * Delete an invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvite(organizationInviteId: string, organizationId: string, options?: any) {
            return OrganizationInvitesApiFp(configuration).deleteInvite(organizationInviteId, organizationId, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Invites
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByOrganizationId(organizationId: string, accepted?: boolean, options?: any) {
            return OrganizationInvitesApiFp(configuration).fetchInvitesByOrganizationId(organizationId, accepted, options)(axios, basePath);
        },
        /**
         * Resend an organisation invite for an existing unaccepted invite
         * @param {string} organizationInviteId Organization Invite id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrganizationInvite(organizationInviteId: string, organizationId: string, options?: any) {
            return OrganizationInvitesApiFp(configuration).resendOrganizationInvite(organizationInviteId, organizationId, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationInvitesApi - interface
 * @export
 * @interface OrganizationInvitesApi
 */
export interface OrganizationInvitesApiInterface {
    /**
     * Accept an organization invite
     * @param {string} token 
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApiInterface
     */
    acceptOrganizationInvite(token: string, organizationId: string, options?: any): AxiosPromise<object>;

    /**
     * Invite a User to an Organization
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApiInterface
     */
    createOrganizationInvite(organizationId: string, createOrganizationInviteDTO: CreateOrganizationInviteDTO, options?: any): AxiosPromise<object>;

    /**
     * Delete an invite
     * @param {string} organizationInviteId Organization Invite id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApiInterface
     */
    deleteInvite(organizationInviteId: string, organizationId: string, options?: any): AxiosPromise<object>;

    /**
     * Get an Organization\'s Invites
     * @param {string} organizationId Organization id
     * @param {boolean} [accepted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApiInterface
     */
    fetchInvitesByOrganizationId(organizationId: string, accepted?: boolean, options?: any): AxiosPromise<Array<OrganizationInviteDTO>>;

    /**
     * Resend an organisation invite for an existing unaccepted invite
     * @param {string} organizationInviteId Organization Invite id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApiInterface
     */
    resendOrganizationInvite(organizationInviteId: string, organizationId: string, options?: any): AxiosPromise<object>;

}

/**
 * OrganizationInvitesApi - object-oriented interface
 * @export
 * @class OrganizationInvitesApi
 * @extends {BaseAPI}
 */
export class OrganizationInvitesApi extends BaseAPI implements OrganizationInvitesApiInterface {
    /**
     * Accept an organization invite
     * @param {string} token 
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApi
     */
    public acceptOrganizationInvite(token: string, organizationId: string, options?: any) {
        return OrganizationInvitesApiFp(this.configuration).acceptOrganizationInvite(token, organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Invite a User to an Organization
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApi
     */
    public createOrganizationInvite(organizationId: string, createOrganizationInviteDTO: CreateOrganizationInviteDTO, options?: any) {
        return OrganizationInvitesApiFp(this.configuration).createOrganizationInvite(organizationId, createOrganizationInviteDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete an invite
     * @param {string} organizationInviteId Organization Invite id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApi
     */
    public deleteInvite(organizationInviteId: string, organizationId: string, options?: any) {
        return OrganizationInvitesApiFp(this.configuration).deleteInvite(organizationInviteId, organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Invites
     * @param {string} organizationId Organization id
     * @param {boolean} [accepted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApi
     */
    public fetchInvitesByOrganizationId(organizationId: string, accepted?: boolean, options?: any) {
        return OrganizationInvitesApiFp(this.configuration).fetchInvitesByOrganizationId(organizationId, accepted, options)(this.axios, this.basePath);
    }

    /**
     * Resend an organisation invite for an existing unaccepted invite
     * @param {string} organizationInviteId Organization Invite id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInvitesApi
     */
    public resendOrganizationInvite(organizationInviteId: string, organizationId: string, options?: any) {
        return OrganizationInvitesApiFp(this.configuration).resendOrganizationInvite(organizationInviteId, organizationId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationInvitesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Accept an organization invite
 * @param {string} token 
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function acceptOrganizationInvite(
    token: string,
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).acceptOrganizationInvite(token, organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Invite a User to an Organization
 * @param {string} organizationId Organization id
 * @param {CreateOrganizationInviteDTO} createOrganizationInviteDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOrganizationInvite(
    organizationId: string,
    createOrganizationInviteDTO: CreateOrganizationInviteDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).createOrganizationInvite(organizationId, createOrganizationInviteDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete an invite
 * @param {string} organizationInviteId Organization Invite id
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteInvite(
    organizationInviteId: string,
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).deleteInvite(organizationInviteId, organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Invites
 * @param {string} organizationId Organization id
 * @param {boolean} [accepted] 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchInvitesByOrganizationId(
    organizationId: string,
    accepted?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationInviteDTO>> {
    const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).fetchInvitesByOrganizationId(organizationId, accepted, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Resend an organisation invite for an existing unaccepted invite
 * @param {string} organizationInviteId Organization Invite id
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resendOrganizationInvite(
    organizationInviteId: string,
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationInvitesApiAxiosParamCreator(configuration).resendOrganizationInvite(organizationInviteId, organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

